import './mask-field-list-ref.scss'

import { PropType } from "vue"
import Component from 'vue-class-component'
import { first } from 'rxjs/operators';
import _ from 'lodash';
import { faTrash } from '@fortawesome/free-solid-svg-icons'

import { EntityField, EntityFieldStatus } from '@skinsoft/types';

import { TranslationDataStore } from '@skinsoft/entity';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntitySelect } from '@skinsoft/ui';

@Component({
    components: {
        sEntitySelect: EntitySelect,
    },
    props: {
        entityField: {
            type: Object as PropType<EntityField>,
        },
        fieldValue: {},
        editing: {
            type: Boolean,
        },
        getStatus: {},
        dataCy: {
            type: String,
        },
    },
    template: require('./mask-field-list-ref.html')
})
export class MaskFieldListRef extends ReactiveVue {
    private entityField: EntityField
    private fieldValue: any
    private editing: Boolean
    private dataCy: string
    private getStatus: (entityField: EntityField) => EntityFieldStatus

    private fieldLabel: string = ""

    private $translationDataStore: TranslationDataStore

    private trashIcon = faTrash

    private get values(): any[] {
        return this.fieldValue ?? []
    }

    private sanitizeValue(value: any): string {
        return _.get(value, 'ref') ?? value
    }

    private onEntitySelected(entity: any, index) {        
        const path = `${this.entityField.path}.${index}`

        this.$emit("value-change", {
            abstractEntity: this.entityField.abstractEntity,
            fieldPath: path,
            value: entity.id,
        })
    }

    private removeEntry(index: number) {
        // browser version required for toSpliced to work are still relativelly recent, wait a little bit longer 
        // before using it
        //const updatedValues = this.values.toSpliced(index, 1)
        const updatedValues = this.values
        updatedValues.splice(index, 1)

        this.$emit("value-change", {
            abstractEntity: this.entityField.abstractEntity,
            fieldPath: this.entityField.path,
            value: updatedValues,
        })
    }

    private thesaurusIdentifierIfNeeded(entityField: EntityField) {
        if (entityField.type.type === "ThesaurusTerm") {
            return entityField.type.thesaurusIdentifier
        }

        if (entityField.type.entityFieldType?.type === "ThesaurusTerm") {
            return entityField.type.entityFieldType.thesaurusIdentifier
        }

        return null
    }

    private fetchLabel(key: string) {
        let translationKey: string = `field.${key}`
        if (this.entityField.entityFields
            && this.entityField.entityFields.length > 0) {
            translationKey += ".complex"
        }
        this.subscribeTo(
            this.$translationDataStore.getMessage(translationKey, this.getAppLocale()).pipe(first()),
            translation => {
                this.fieldLabel = translation
            },
            'translation-subscription'
        )
    }

    private isReadonly(entityField: EntityField) {
        return !this.editing || entityField.isReadOnly || this.getStatus(entityField).disabled
    }

    private infoMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).disabledMessage
    }

    private errorMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).errorMessage
    }

    private hasError(entityField: EntityField) {
        return this.getStatus(entityField).error
    }

    private getDataCy(index?: number): String {
        let res: string = this.entityField.path
        if(this.dataCy) {
            res = this.dataCy
        }
        if(index !== undefined && index !== null) {
            res = `${res}.${index}`
        }

        return res
    }

    private getKey(index: number) {
        const value = this.values[index]

        if(value) {
            if(value instanceof String || typeof value === 'string') {
                return this.entityField.name + '-' + index + '-' + value
            } else {
                return this.entityField.name + '-' + index + '-' + JSON.stringify(value)
            }
        }

        return this.entityField.name + '-' + index
    }
}